import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UserService } from '@sparro/api/user/user.service';
import { BookmarkService } from '@sparro/app/core/api/bookmark/bookmark.service';
import { SnackbarService } from '@sparro/app/core/helpers/toastr/snackbar.service';
import { Project } from '@sparro/app/core/models/project.model';
import { User } from '@sparro/app/core/models/user.model';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-project-card-header',
  templateUrl: './project-card-header.component.html',
  styleUrls: ['./project-card-header.component.scss']
})
export class ProjectCardHeaderComponent implements OnInit {
  @Input() project: Project;
  @Input() self: boolean = false;
  @Input() showContextMenu: boolean = false;
  @Output() removedProject = new EventEmitter();

  icons = {
    bookmark:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/addtocollection/default-48x8.svg',
    bookmark_fill:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/addtocollection/fill-48x48.svg'
  };
  source = 'neo_projects';
  fullName: string;
  fullNameTruncated: string;
  user: User;

  constructor(
    private bookmarkService: BookmarkService,
    private userService: UserService,
    private snackbarService: SnackbarService,
  ) { }

  ngOnInit(): void {
    this.getAuthUser();
    this.nameDisplayed(this.project?.owners[0]?.user);
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe((initialized: boolean) => {
      if (initialized) {
        this.userService.user.subscribe((user: User) => {
          this.user = user;
        });
      }
    });
  }

  nameDisplayed(owner: User): void {
    this.fullName = `${owner.first_name} ${owner.last_name}`;
    const nameFragments = this.fullName.split(' ');
    if (this.project.owners.length > 1 && this.fullName.length <= 17) {
      this.fullNameTruncated = this.fullName;
    } else if (this.project.owners.length == 1 && this.fullName.length <= 24) {
      this.fullNameTruncated = this.fullName;
    } else if (this.project.owners.length > 1 && this.fullName.length > 17) {
      this.fullNameTruncated =
        nameFragments.slice(0, this.ownerLimit(nameFragments, 17)).join(' ') + '...';
    } else if (this.project.owners.length == 1 && this.fullName.length > 24) {
      this.fullNameTruncated =
        nameFragments.slice(0, this.ownerLimit(nameFragments, 24)).join(' ') + '...';
    } else if (this.project.owners.length == 1 && owner.first_name.length > 24) {
      this.fullNameTruncated = owner.first_name.slice(0, 24) + '...';
    } else if (this.project.owners.length > 1 && owner.first_name.length > 17) {
      this.fullNameTruncated = owner.first_name.slice(0, 17) + '...';
    }
  }

  ownerLimit(nameFragments: string[], nameLimit: number): number {
    let count = 0;
    while (true) {
      count++;
      if (nameFragments.slice(0, count).join(' ').length > nameLimit) {
        return count - 1;
      }
    }
  }

  goToProfile(user: User): void {
    const url = `${environment.profileUrl}${user.username}/`;
    window.open(url, '_blank');
  }

  toggleBookmark() {
    if (!this.user) {
      this.snackbarService.error('To perform this action, login or sign-up');
      this.redirectToLogin();
    } else {
      if (this.project.bookmark) {
        this.bookmarkService
          .removeFromCollection(this.source, this.project.slug, this.project.bookmark?.id)
          .subscribe((response: any) => {
            if (response) {
              this.bookmarkService.removeBookmarks(this.project);
              this.project.bookmark = null;
              this.snackbarService.success('Removed from collection');
            }
          });
      } else {
        const data = {
          user: this.user.id
        };
        this.bookmarkService.addToCollection(this.source, this.project.slug, data).subscribe(
          (response: any) => {
            this.project.bookmark = response;
            this.snackbarService.success('Added to collection');
          },
          err => {
            console.log(err);
          }
        );
      }
    }
  }

  redirectToLogin() {
    window.location.href = `${environment.loginUrl}authentication?service=sign-in&continue=${window.location.href}`;
  }

  getProfileUrl(user: User): string {
    return `${environment.profileUrl}${user.username}/`;
  }
}
